import React, { useRef, useEffect, useState } from "react";
import { Button, Dropdown, message, ConfigProvider, Select } from "antd";
import { useHistory } from "react-router-dom";
import jwt from "../../utils/jwt";
import "./navBar.scss";
import Header from "../header";
import mixpanel from "mixpanel-browser";
import {
  operatorType,
  mixPanelToken,
  isStage,
  businessModelType,
} from "../../config";

const Navbar = (props) => {
  const { isMobile, selectedKey } = props;
  const [sidebar, setSidebar] = useState(false);

  const history = useHistory();

  const showSidebar = () => {
    setSidebar(!sidebar);
  };

  const deleteToken = () => {
    history.push("login");
    localStorage.removeItem("idToken");
    localStorage.removeItem("consentGivenAt")
    localStorage.removeItem("refreshToken");
    localStorage.removeItem("userType");
  };
  const token = localStorage.getItem("idToken");
  const decodedToken = jwt.decode(token);
  let userName = decodedToken.name || decodedToken.mgName;
  let userType = decodedToken.userType || "OPERATOR";
  if (sessionStorage.getItem("userType")) {
    userType = sessionStorage.getItem("userType");
  } else if (decodedToken && decodedToken.isElectricUser) {
    userName = decodedToken.electricName;
    userType = "ELECTRIC";
  }
  const mobile_number = decodedToken.mobileNo;

  const routeChange = (path) => {
    let page = "default";
    // write all the selectedKey tracking here
    if (selectedKey == 1) {
      page = "Home Page";
    } else if (selectedKey == 2) {
      page = "Inspection Data Page";
    } else if (selectedKey == 3) {
      page = "Feedback Page";
    } else if (selectedKey == 4) {
      page = "Audit Data Page";
    } else if (selectedKey == 6) {
      page = "My Buses Page";
    } else if (selectedKey == 7) {
      page = "Service Contracts Page";
    } else if (selectedKey == 8) {
      page = "Payment Summary Page";
    } else if (selectedKey == 9) {
      page = "Trips & Revenue Page";
    } else if (selectedKey == 10) {
      page = "Reimbursements Page";
    } else if (selectedKey == 7.1) {
      page = "Wallet Page";
    } else if (selectedKey == 11 || selectedKey == 7.2) {
      page = "Agreement Tracking Page";
    } else if (selectedKey == 2.2) {
      page = "Operator Deals Page";
    } else if (selectedKey == 4.2) {
      page = "Offline Seat Fare Page";
    } else if (selectedKey == 3.2) {
      page = "Offline Commission Page";
    } else if (selectedKey == 5.2) {
      page = "Payouts Page";
    } else if (selectedKey == 6.2) {
      page = "KYC Page";
    }

    const business_model_type = businessModelType.find(
      (opt) => opt.value === userType
    )?.label;
    mixpanel.init(mixPanelToken, { debug: isStage });

    if (path == "/") {
      mixpanel.track("Home Tab Clicked", {
        mobile_number,
        view_from: page,
        type:
          userType === "ELECTRIC" || userType === "MG" ? "BUSOWNER" : userType,
        business_model_type,
      });
    } else if (path == "resources") {
      mixpanel.track("Resources Data Tab Clicked", {
        mobile_number,
        view_from: page,
        type: userType,
        business_model_type,
      });
    } else if (path == "inspectionDataDetails") {
      mixpanel.track("Inspection Data Tab Clicked", {
        mobile_number,
        view_from: page,
        type: userType,
        business_model_type,
      });
    } else if (path == "feedbackDetails") {
      mixpanel.track("Feedback Tab Clicked", {
        mobile_number,
        view_from: page,
        type: userType,
        business_model_type,
      });
    } else if (path == "auditDataDetails") {
      mixpanel.track("Audit Data Tab Clicked", {
        mobile_number,
        view_from: page,
        type: userType,
        business_model_type,
      });
    } else if (path == "reimbursements") {
      mixpanel.track("Reimbursements Tab Clicked", {
        mobile_number,
        view_from: page,
        type: userType,
        business_model_type,
      });
    } else if (path == "myBuses") {
      mixpanel.track("My Buses Option Clicked", {
        mobile_number,
        view_from: page,
        type: userType,
        business_model_type,
      });
    } else if (path == "serviceContracts") {
      mixpanel.track("Service Contract Option Clicked", {
        mobile_number,
        view_from: page,
        type: userType,
        business_model_type,
      });
    } else if (path == "paymentSummary") {
      mixpanel.track("Payment Summary Option Clicked", {
        mobile_number,
        view_from: page,
        type: userType,
        business_model_type,
      });
    } else if (path == "tripsRevenue") {
      mixpanel.track("Trips & Revenue Option Clicked", {
        mobile_number,
        view_from: page,
        type: userType,
        business_model_type,
      });
    } else if (path == "wallet") {
      mixpanel.track("Wallet Tab Clicked", {
        mobile_number,
        view_from: page,
        type:
          userType === "ELECTRIC" || userType === "MG" ? "BUSOWNER" : userType,
        business_model_type,
      });
    } else if (path == "agreement-tracking") {
      mixpanel.track("Agreement Tracking Tab Clicked", {
        mobile_number,
        view_from: page,
        type:
          userType === "ELECTRIC" || userType === "MG" ? "BUSOWNER" : userType,
        business_model_type,
      });
    } else if (path == "operatorDealsDetails") {
      mixpanel.track("Operator Deals Tab Clicked", {
        mobile_number,
        view_from: page,
        type:
          userType === "ELECTRIC" || userType === "MG" ? "BUSOWNER" : userType,
        business_model_type,
      });
    } else if (path == "offlineCommission") {
      mixpanel.track("Offline Comission Tab Clicked", {
        mobile_number,
        view_from: page,
        type:
          userType === "ELECTRIC" || userType === "MG" ? "BUSOWNER" : userType,
        business_model_type,
      });
    } else if (path == "seatFare") {
      mixpanel.track("Offline Seat Fare Tab Clicked", {
        mobile_number,
        view_from: page,
        type:
          userType === "ELECTRIC" || userType === "MG" ? "BUSOWNER" : userType,
        business_model_type,
      });
    } else if (path == "kyc") {
      mixpanel.track("KYC Tab Clicked", {
        mobile_number,
        view_from: page,
        type:
          userType === "ELECTRIC" || userType === "MG" ? "BUSOWNER" : userType,
        business_model_type,
      });
    } else if (path == "payouts") {
      mixpanel.track("Payouts Tab Clicked", {
        mobile_number,
        view_from: page,
        type:
          userType === "ELECTRIC" || userType === "MG" ? "BUSOWNER" : userType,
        business_model_type,
      });
    }
    history.push(path);
    setSidebar(!sidebar);
  };

  const items = [
    {
      label: "My Buses",
      key: "1",
    },
    {
      label: "Service Contracts",
      key: "2",
    },
    {
      label: "Payment Summary",
      key: "3",
    },
    {
      label: "Trips & Revenue",
      key: "4",
    },
    {
      label: "Agreement Tracking",
      key: "5",
    },
  ];

  const billing = [
    {
      label: "Create Invoice",
      key: "1",
    },
    {
      label: "Submitted Invoice",
      key: "2",
    },
  ];

  const onClick = ({ key }) => {
    if (key == 1) {
      routeChange("myBuses");
    } else if (key == 2) {
      routeChange("serviceContracts");
    } else if (key == 3) {
      routeChange("paymentSummary");
    } else if (key == 4) {
      routeChange("tripsRevenue");
    } else if (key == 5) {
      routeChange("agreement-tracking");
    } else message.info(`Click on item ${key}`);
  };

  const onBillingClick = ({ key }) => {
    if (key == 1) {
      routeChange("createInvoice");
    } else if (key == 2) {
      routeChange("submittedInvoices");
    } else message.info(`Click on item ${key}`);
  };

  if (userType && userType === operatorType.CABOWNER) {
    return (
      <>
        <Header deleteToken={deleteToken} routeChange={routeChange} />
        <div className="desktopContainer">
          <div>
            <div
              onClick={() => {
                routeChange("/");
              }}
            >
              <div className="deals">
                {selectedKey === 1 ? (
                  <>
                    <img
                      src="https://d1flzashw70bti.cloudfront.net/original/images/optdash/home-outline1(2).svg"
                      alt="home"
                    />

                    <p className="dealNameColored">Home</p>
                  </>
                ) : (
                  <>
                    <img
                      src="https://d1flzashw70bti.cloudfront.net/original/images/optdash/home-outline1(1).svg"
                      alt="home"
                    />

                    <p className="dealName">Home</p>
                  </>
                )}
              </div>
              <div className="grey"></div>
            </div>
            <div
              onClick={() => {
                routeChange("/trips");
              }}
            >
              <div className="deals">
                {selectedKey === 6 ? (
                  <>
                    <img
                      src="https://d1flzashw70bti.cloudfront.net/original/images/opt/dash/trips1.svg"
                      alt="ticket"
                    />

                    <p className="dealNameColored">Trips</p>
                  </>
                ) : (
                  <>
                    <img
                      src="https://d1flzashw70bti.cloudfront.net/original/images/opt/dash/trip2.svg"
                      alt="deals"
                    />

                    <p className="dealName">Trips</p>
                  </>
                )}
              </div>
              <div className="grey"></div>
            </div>
            <div
              onClick={() => {
                routeChange("/fmlmPaymentSummary");
              }}
            >
              <div className="deals">
                {selectedKey === 4 ? (
                  <>
                    <img
                      src="https://d1flzashw70bti.cloudfront.net/original/images/optdash/navbar/rupeePurp.svg"
                      alt="ticket"
                    />

                    <p className="dealNameColored">Payment Summary</p>
                  </>
                ) : (
                  <>
                    <img
                      src="https://d1flzashw70bti.cloudfront.net/original/images/optdash/rupee/ruppeblack.svg"
                      alt="deals"
                    />

                    <p className="dealName">Payment Summary</p>
                  </>
                )}
              </div>
              <div className="grey"></div>
            </div>
            <div
              onClick={() => {
                routeChange("cabKYC");
              }}
            >
              <div className="deals">
                {selectedKey == 8 ? (
                  <>
                    <img
                      src="https://d1flzashw70bti.cloudfront.net/original/images/operator/navbar/payoutCol.svg"
                      alt="kyc"
                    />
                    <p className="dealNameColored">KYC</p>
                  </>
                ) : (
                  <>
                    <img
                      src="https://d1flzashw70bti.cloudfront.net/original/images/operator/navbar/payout.svg"
                      alt="kyc"
                    />
                    <p className="dealName">KYC</p>
                  </>
                )}
              </div>
              <div className="grey"></div>
            </div>
            <div>
              <div className="deals">
                <ConfigProvider
                  theme={{
                    token: {
                      colorPrimary: "#7b2bff",
                    },
                  }}
                >
                  <Dropdown
                    menu={{
                      items: billing,
                      selectable: true,
                      onClick: onBillingClick,
                      defaultSelectedKeys:
                        selectedKey == 9
                          ? [`9`]
                          : selectedKey == 10
                          ? [`10`]
                          : null,
                    }}
                  >
                    <a onClick={(e) => e.preventDefault()}>
                      {selectedKey == 9 || selectedKey == 10 ? (
                        <img
                          src="https://d1flzashw70bti.cloudfront.net/original/images/operator/buscol.svg"
                          alt="bus"
                        />
                      ) : (
                        <img
                          src="https://d1flzashw70bti.cloudfront.net/original/images/operator/bus.svg "
                          alt="bus"
                        />
                      )}
                      {selectedKey == 9 || selectedKey == 10 ? (
                        <p className="dealNameColored">Billing</p>
                      ) : (
                        <p className="dealName">Billing</p>
                      )}
                    </a>
                  </Dropdown>
                </ConfigProvider>
              </div>
            </div>
          </div>
        </div>
      </>
    );
  } else if (userType === operatorType.BUSOWNER) {
    return (
      <>
        <Header deleteToken={deleteToken} routeChange={routeChange} />
        <div className="desktopContainer">
          <div>
            <div
              onClick={() => {
                routeChange("/");
              }}
            >
              <div className="deals">
                {selectedKey == 1 ? (
                  <>
                    <img
                      src="https://d1flzashw70bti.cloudfront.net/original/images/operator/navbar/homeCol.svg"
                      alt="home"
                    />

                    <p className="dealNameColored">Home</p>
                  </>
                ) : (
                  <>
                    <img
                      src="https://d1flzashw70bti.cloudfront.net/original/images/operato/navbar/home.svg"
                      alt="home"
                    />

                    <p className="dealName">Home</p>
                  </>
                )}
              </div>
              <div className="grey"></div>
            </div>
            <div
              onClick={() => {
                routeChange("inspectionDataDetails");
              }}
            >
              <div className="deals">
                {selectedKey == 2 ? (
                  <>
                    <img
                      src="https://d1flzashw70bti.cloudfront.net/original/images/operator/navbar/ticketCol.svg"
                      alt="ticket"
                    />
                    <p className="dealNameColored">Inspection Data</p>
                  </>
                ) : (
                  <>
                    <img
                      src="https://d1flzashw70bti.cloudfront.net/original/images/operator/navbar/ticker.svg"
                      alt="deals"
                    />
                    <p className="dealName">Inspection Data</p>
                  </>
                )}
              </div>
              <div className="grey"></div>
            </div>
            <div
              onClick={() => {
                routeChange("auditDataDetails");
              }}
            >
              <div className="deals">
                {selectedKey == 3 ? (
                  <>
                    <img
                      src="https://d1flzashw70bti.cloudfront.net/original/images/operator/navbar/ticketCol.svg"
                      alt="ticket"
                    />
                    <p className="dealNameColored">Audit Data</p>
                  </>
                ) : (
                  <>
                    <img
                      src="https://d1flzashw70bti.cloudfront.net/original/images/operator/navbar/ticker.svg"
                      alt="deals"
                    />
                    <p className="dealName">Audit Data</p>
                  </>
                )}
              </div>
              <div className="grey"></div>
            </div>
            <div
              onClick={() => {
                routeChange("feedbackDetails");
              }}
            >
              <div className="deals">
                {selectedKey == 4 ? (
                  <>
                    <img
                      src="https://d1flzashw70bti.cloudfront.net/original/images/operator/navbar/ticketCol.svg"
                      alt="ticket"
                    />
                    <p className="dealNameColored">Feedback</p>
                  </>
                ) : (
                  <>
                    <img
                      src="https://d1flzashw70bti.cloudfront.net/original/images/operator/navbar/ticker.svg"
                      alt="deals"
                    />
                    <p className="dealName">Feedback</p>
                  </>
                )}
              </div>
              <div className="grey"></div>
            </div>
              <div
                onClick={() => {
                  routeChange("resources");
                }}
              >
                <div className="deals">
                  {selectedKey == 17 ? (
                    <>
                      <img
                        src="https://d1flzashw70bti.cloudfront.net/original/images/operator/resources.svg"
                        alt="resources"
                      />
                      <p className="dealNameColored">Resources</p>
                    </>
                  ) : (
                    <>
                      <img
                        src="https://d1flzashw70bti.cloudfront.net/original/images/operator/resources.svg"
                        alt="resources"
                      />
                      <p className="dealName">Resources</p>
                    </>
                  )}
                </div>
                <div className="grey"></div>
              </div>
            <div
              onClick={() => {
                routeChange("reimbursements");
              }}
            >
              <div className="deals">
                {selectedKey == 10 ? (
                  <>
                    <img
                      src="https://d1flzashw70bti.cloudfront.net/original/images/operator/buscol.svg"
                      alt="bus"
                    />
                    <p className="dealNameColored">Reimbursements</p>
                  </>
                ) : (
                  <>
                    <img
                      src="https://d1flzashw70bti.cloudfront.net/original/images/operator/bus.svg "
                      alt="bus"
                    />
                    <p className="dealName">Reimbursements</p>
                  </>
                )}
              </div>
              <div className="grey"></div>
            </div>
            <div>
              <div className="deals">
                <ConfigProvider
                  theme={{
                    token: {
                      colorPrimary: "#7b2bff",
                    },
                  }}
                >
                  <Dropdown
                    menu={{
                      items,
                      selectable: true,
                      onClick,
                      defaultSelectedKeys:
                        selectedKey == 6
                          ? [`1`]
                          : selectedKey == 7
                          ? [`2`]
                          : selectedKey == 8
                          ? [`3`]
                          : selectedKey == 9
                          ? [`4`]
                          : selectedKey == 11
                          ? [`5`]
                          : null,
                    }}
                  >
                    <a onClick={(e) => e.preventDefault()}>
                      {selectedKey == 6 ||
                      selectedKey == 7 ||
                      selectedKey == 8 ||
                      selectedKey == 9 ||
                      selectedKey == 11 ? (
                        <img
                          src="https://d1flzashw70bti.cloudfront.net/original/images/operator/buscol.svg"
                          alt="bus"
                        />
                      ) : (
                        <img
                          src="https://d1flzashw70bti.cloudfront.net/original/images/operator/bus.svg "
                          alt="bus"
                        />
                      )}
                      {selectedKey == 6 ||
                      selectedKey == 7 ||
                      selectedKey == 8 ||
                      selectedKey == 9 ||
                      selectedKey == 11 ? (
                        <p className="dealNameColored">My Buses & Payments</p>
                      ) : (
                        <p className="dealName">My Buses & Payments</p>
                      )}
                    </a>
                  </Dropdown>
                </ConfigProvider>
              </div>
            </div>
          </div>
        </div>
      </>
    );
  } else if (userType === "ELECTRIC") {
    return (
      <>
        <Header deleteToken={deleteToken} routeChange={routeChange} />
        <div className="desktopContainer">
          <div>
            <div
              onClick={() => {
                routeChange("/");
              }}
            >
              <div className="deals">
                {selectedKey == 1 ? (
                  <>
                    <img
                      src="https://d1flzashw70bti.cloudfront.net/original/images/operator/navbar/homeCol.svg"
                      alt="home"
                    />

                    <p className="dealNameColored">Home</p>
                  </>
                ) : (
                  <>
                    <img
                      src="https://d1flzashw70bti.cloudfront.net/original/images/operato/navbar/home.svg"
                      alt="home"
                    />

                    <p className="dealName">Home</p>
                  </>
                )}
              </div>
              <div className="grey"></div>
            </div>

            <div
              onClick={() => {
                routeChange("wallet");
              }}
            >
              <div className="deals">
                {selectedKey == 7.1 ? (
                  <>
                    <img
                      src="https://d1flzashw70bti.cloudfront.net/original/images/operator/wallet.svg"
                      alt="wallet"
                    />
                    <p className="dealNameColored">Wallet</p>
                  </>
                ) : (
                  <>
                    <img
                      src="https://d1flzashw70bti.cloudfront.net/original/images/operator/wallet.svg"
                      alt="wallet"
                    />
                    <p className="dealName">Wallet</p>
                  </>
                )}
              </div>
              <div className="grey"></div>
            </div>
            <div
              onClick={() => {
                routeChange("agreement-tracking");
              }}
            >
              <div className="deals">
                {selectedKey == 7.2 ? (
                  <>
                    <img
                      src="https://d1flzashw70bti.cloudfront.net/original/images/operator/buscol.svg"
                      alt="agreement tracking"
                    />
                    <p className="dealNameColored">Agreement Tracking</p>
                  </>
                ) : (
                  <>
                    <img
                      src="https://d1flzashw70bti.cloudfront.net/original/images/operator/bus.svg"
                      alt="agreement tracking"
                    />
                    <p className="dealName">Agreement Tracking</p>
                  </>
                )}
              </div>
              <div className="grey"></div>
            </div>
          </div>
        </div>
      </>
    );
  } else {
    if (isMobile) {
      return (
        <div>
          <div className="navbar">
            <img
              src="https://d1flzashw70bti.cloudfront.net/original/images/operatorDashboard/homePage/logo.svg"
              alt="zingbus"
            />
            <img
              src="https://d1flzashw70bti.cloudfront.net/original/images/operatorDashBoard/home/hamburger1.svg"
              alt="hamburger"
              onClick={showSidebar}
            />
          </div>
          <div className="grey"></div>
          <div
            onClick={showSidebar}
            className={sidebar ? "navbackground" : null}
          ></div>
          <div className={sidebar ? "nav-menu active" : "nav-menu"}>
            <div className="header">
              <span>Menu</span>
              <img
                src="https://d1flzashw70bti.cloudfront.net/next-gen/images/operatorDashboard/navbar/close.webp"
                alt="close"
                onClick={showSidebar}
              />
            </div>
            <div
              onClick={() => {
                routeChange("profile");
              }}
            >
              <div className="profileDetails">
                <img
                  src="https://d1flzashw70bti.cloudfront.net/original/images/operatorDashBoard/home/profilePhoto.svg"
                  alt="profilePhoto"
                />
                <div>
                  <p className="operatorName">Hi {userName}</p>
                  <p>{decodedToken.mobileNo}</p>
                </div>
                <img
                  src="https://d1flzashw70bti.cloudfront.net/next-gen/images/operatorDashboard/navBar/arrow.webp"
                  alt="arrow"
                />
              </div>
            </div>
            <div
              onClick={() => {
                routeChange("operatorDealsDetails");
              }}
            >
              <div className="deals">
                <img
                  src="https://d1flzashw70bti.cloudfront.net/original/images/operatorDashboard/navbar/deals.svg"
                  alt="deals"
                />
                <p className="dealName">Operator Deals</p>
                <img
                  src="https://d1flzashw70bti.cloudfront.net/next-gen/images/operatorDashboard/navBar/arrow.webp"
                  alt="arrow"
                />
              </div>
              <div className="grey"></div>
            </div>
            <div
              onClick={() => {
                routeChange("pricing");
              }}
            >
              <div className="deals">
                <img
                  src="https://d1flzashw70bti.cloudfront.net/original/images/operatorDashboard/navBar/pricing.svg"
                  alt="deals"
                />
                <p className="dealName">Offline Pricing</p>
                <img
                  src="https://d1flzashw70bti.cloudfront.net/next-gen/images/operatorDashboard/navBar/arrow.webp"
                  alt="arrow"
                />
              </div>
              <div className="grey"></div>
            </div>
            <div
              onClick={() => {
                routeChange("offlineCommission");
              }}
            >
              <div className="deals">
                <img
                  src="https://d1flzashw70bti.cloudfront.net/original/images/operatorDashboard/navBar/pricing.svg"
                  alt="deals"
                />
                <p className="dealName">Offline Commission</p>
                <img
                  src="https://d1flzashw70bti.cloudfront.net/next-gen/images/operatorDashboard/navBar/arrow.webp"
                  alt="arrow"
                />
              </div>
              <div className="grey"></div>
            </div>
            <div
              onClick={() => {
                routeChange("seatFare");
              }}
            >
              <div className="deals">
                <img
                  src="https://d1flzashw70bti.cloudfront.net/original/images/operatorDashboard/navBar/pricing.svg"
                  alt="deals"
                />
                <p className="dealName">B2B Flat Fare</p>
                <img
                  src="https://d1flzashw70bti.cloudfront.net/next-gen/images/operatorDashboard/navBar/arrow.webp"
                  alt="arrow"
                />
              </div>
              <div className="grey"></div>
            </div>
            <div
              onClick={() => {
                routeChange("login");
              }}
            >
              <Button className="confirmButton" onClick={deleteToken}>
                Logout
              </Button>
            </div>
          </div>
        </div>
      );
    } else {
      return (
        <>
          <Header deleteToken={deleteToken} routeChange={routeChange} />
          <div className="desktopContainer">
            <div>
              <div
                onClick={() => {
                  routeChange("/");
                }}
              >
                <div className="deals">
                  {selectedKey == 1 ? (
                    <>
                      <img
                        src="https://d1flzashw70bti.cloudfront.net/original/images/operator/navbar/homeCol.svg"
                        alt="home"
                      />

                      <p className="dealNameColored">Home</p>
                    </>
                  ) : (
                    <>
                      <img
                        src="https://d1flzashw70bti.cloudfront.net/original/images/operato/navbar/home.svg"
                        alt="home"
                      />

                      <p className="dealName">Home</p>
                    </>
                  )}
                </div>
                <div className="grey"></div>
              </div>
              <div
                onClick={() => {
                  routeChange("operatorDealsDetails");
                }}
              >
                <div className="deals">
                  {selectedKey == 2.2 ? (
                    <>
                      <img
                        src="https://d1flzashw70bti.cloudfront.net/original/images/operator/navbar/ticketCol.svg"
                        alt="ticket"
                      />
                      <p className="dealNameColored">Operator Deals</p>
                    </>
                  ) : (
                    <>
                      <img
                        src="https://d1flzashw70bti.cloudfront.net/original/images/operator/navbar/ticker.svg"
                        alt="deals"
                      />
                      <p className="dealName">Operator Deals</p>
                    </>
                  )}
                </div>
                <div className="grey"></div>
              </div>
              <div
                onClick={() => {
                  routeChange("offlineCommission");
                }}
              >
                <div className="deals">
                  {selectedKey == 3.2 ? (
                    <>
                      <img
                        src="https://d1flzashw70bti.cloudfront.net/original/images/operator/navbar/offlineComissionCol.svg"
                        alt="commission"
                      />

                      <p className="dealNameColored">Offline Commission</p>
                    </>
                  ) : (
                    <>
                      <img
                        src="https://d1flzashw70bti.cloudfront.net/original/images/operator/navbar/offlineComission.svg"
                        alt="commission"
                      />
                      <p className="dealName">Offline Commission</p>
                    </>
                  )}
                </div>
                <div className="grey"></div>
              </div>
              <div
                onClick={() => {
                  routeChange("seatFare");
                }}
              >
                <div className="deals">
                  {selectedKey == 4.2 ? (
                    <>
                      <img
                        src="https://d1flzashw70bti.cloudfront.net/original/images/operator/navbar/b2cFare.svg"
                        alt="fare"
                      />
                      <p className="dealNameColored">Offline Seat Fare</p>
                    </>
                  ) : (
                    <>
                      <img
                        src="https://d1flzashw70bti.cloudfront.net/original/images/operator/navbar/fare.svg"
                        alt="fare"
                      />
                      <p className="dealName">Offline Seat Fare</p>
                    </>
                  )}
                </div>
                <div className="grey"></div>
              </div>
              <div
                onClick={() => {
                  routeChange("payouts");
                }}
              >
                <div className="deals">
                  {selectedKey == 5.2 ? (
                    <>
                      <img
                        src="https://d1flzashw70bti.cloudfront.net/original/images/operator/navbar/payoutCol.svg"
                        alt="payout"
                      />
                      <p className="dealNameColored">Payouts</p>
                    </>
                  ) : (
                    <>
                      <img
                        src="https://d1flzashw70bti.cloudfront.net/original/images/operator/navbar/payout.svg"
                        alt="payout"
                      />
                      <p className="dealName">Payouts</p>
                    </>
                  )}
                </div>
                <div className="grey"></div>
              </div>
              <div
                onClick={() => {
                  routeChange("kyc");
                }}
              >
                <div className="deals">
                  {selectedKey == 6.2 ? (
                    <>
                      <img
                        src="https://d1flzashw70bti.cloudfront.net/original/images/operator/navbar/payoutCol.svg"
                        alt="kyc"
                      />
                      <p className="dealNameColored">KYC</p>
                    </>
                  ) : (
                    <>
                      <img
                        src="https://d1flzashw70bti.cloudfront.net/original/images/operator/navbar/payout.svg"
                        alt="kyc"
                      />
                      <p className="dealName">KYC</p>
                    </>
                  )}
                </div>
                <div className="grey"></div>
              </div>
            </div>
          </div>
        </>
      );
    }
  }
};
export default Navbar;
